import { ApiFlatItem } from "../../types/general";
import { axiosAWSConsumer as axiosConsumer } from "../../utils";

const fetchFlatItems = async (route: string): Promise<ApiFlatItem[]> => {
  try {
    const { data } = await axiosConsumer.get(route);
    return data.result;
  } catch (error) {
    return [];
  }
};
export const damageItemTypes = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/all_item_type`);

export const materialTypes = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/all_material`);

export const manufacturers = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/all_manufacturer`);

export const colors = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/all_color`);

export const actionsTaken = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/actions_taken_lookup_values`);

export const specificDamages = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/specific_damage_lookup_values`);

export const howDidOccur = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/how_did_it_occur_lookup_values`);

export const damageTypes = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/damage_type_lookup_values`);

export const specificLocations = async (): Promise<ApiFlatItem[]> =>
  fetchFlatItems(`/specific_location_lookup_values`);

export const crmOptions = async (): Promise<ApiFlatItem[]> => {
  const { data } = await axiosConsumer.get(`/ace2/claim/options/matl_dmgs`);
  return data?.result || [];
};
